import {useState, useEffect} from "react";
import {Navbar, Nav, Container} from "react-bootstrap";
import logo from '../assets/img/logo.png';
import {HashLink} from 'react-router-hash-link';
import {
    BrowserRouter as Router
} from "react-router-dom";

export const NavBar = () => {

    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            // Keep navbar in scrolled state whenever user is not at the very top
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }

        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, [])

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }

    return (
        <Router>
            <Navbar expand="md" className={scrolled ? "scrolled" : ""} expanded={expanded} onToggle={setExpanded}>
                <Container>
                    <Navbar.Brand href="#">
                        <img src={logo} alt="Logo" style={{width: '70px', height: 'auto'}}/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)}>
                        <svg className={`ham hamRotate ham1 ${expanded ? 'active' : ''}`} viewBox="0 0 100 100"
                             width="60">
                            <path className="line top"
                                  d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"/>
                            <path className="line middle" d="m 30,50 h 40"/>
                            <path className="line bottom"
                                  d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"/>
                        </svg>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link href="#home"
                                      className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'}
                                      onClick={() => {
                                          onUpdateActiveLink('home');
                                          setExpanded(false);
                                      }}>Home</Nav.Link>
                            <Nav.Link href="#skills"
                                      className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'}
                                      onClick={() => {
                                          onUpdateActiveLink('skills');
                                          setExpanded(false);
                                      }}>Vaardigheden</Nav.Link>
                            <Nav.Link href="#projects"
                                      className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'}
                                      onClick={() => {
                                          onUpdateActiveLink('projects');
                                          setExpanded(false);
                                      }}>Projecten & Stage</Nav.Link>
                            <Nav.Link href="#about-me"
                                      className={activeLink === 'about-me' ? 'active navbar-link' : 'navbar-link'}
                                      onClick={() => {
                                          onUpdateActiveLink('about-me');
                                          setExpanded(false);
                                      }}>Over mij</Nav.Link>
                        </Nav>
                        <span className="navbar-text">
                          <HashLink to='#contact' onClick={() => setExpanded(false)}>
                            <button className="vvd"><span>Contact</span></button>
                          </HashLink>
                        </span>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Router>
    )
}
